function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  id: "backgroundrect",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  fill: "none",
  stroke: "none"
});
var _ref2 = /*#__PURE__*/React.createElement("title", null, "Layer 1");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  id: "svg_1",
  className: "selected",
  fill: "#ebeb1a",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.47729C9.22113 8.47729 8.18182 9.5166 8.18182 10.7955C8.18182 12.0743 9.22113 13.1136 10.5 13.1136C11.7789 13.1136 12.8182 12.0743 12.8182 10.7955C12.8182 9.5166 11.7788 8.47729 10.5 8.47729Z",
  fill: "#ebeb1a",
  id: "svg_2",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 5C6.63637 5 3.33683 7.40316 2 10.7955C3.33683 14.1877 6.63637 16.5909 10.5 16.5909C14.3675 16.5909 17.6632 14.1877 19 10.7955C17.6632 7.40316 14.3675 5 10.5 5ZM10.5 14.6591C8.36729 14.6591 6.63637 12.9282 6.63637 10.7954C6.63637 8.66269 8.36729 6.93181 10.5 6.93181C12.6327 6.93181 14.3637 8.66273 14.3637 10.7955C14.3637 12.9282 12.6327 14.6591 10.5 14.6591Z",
  fill: "#ebeb1a",
  id: "svg_3",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 17.5L18 4.5",
  strokeWidth: 2,
  id: "svg_4",
  fill: "#ebeb1a",
  fillOpacity: 1
}));
function SvgEyeShowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _ref2, _ref3));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShowIcon);
export default __webpack_public_path__ + "static/media/eye-show-icon.3836aea9.svg";
export { ForwardRef as ReactComponent };